import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { MenuItem, Select } from "@material-ui/core";
// import "./Tableform.css";
import image from "../../../../images/logo1.png";
import { connect } from "react-redux";
import {
  getBiomarkerScreening,
  getBookingById,
  getBiomarkerUltasound,
  // getAdditionalMember,
} from "../../../actions/GenomicsSampleAccessioningActions";
import ReactToPrint from "react-to-print";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) =>
  createStyles({
    pageBreak: {
      pageBreakAfter: "always",
    },
    root: {
      "& > *": {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: "none",
    },
    rightContentHeader: {
      width: "88%",
      float: "left",
      textAlign: "left",
      paddingRight: "20px",
    },
  })
);

interface Props {
  match: any;
  getBiomarkerScreening: any;
  biomarkerScreening: any;
  loading: Boolean;
  booking: any;
  getBookingById: any;
  getBiomarkerUltasound: any;
  biomarkerUltasound: any;
  // getAdditionalMember: any;
  markerAdditionMember: any;
}

const BiomarkerScreeningTestRequistionFrom: React.FC<Props> = ({
  match,
  booking,
  getBookingById,
  getBiomarkerScreening,
  biomarkerScreening,
  loading,
  getBiomarkerUltasound,
  biomarkerUltasound,
  // getAdditionalMember,
  markerAdditionMember,

}) => {
  const booking_id = match.params.id;

  const classes = useStyles();
  const history = useHistory();
  const [personName, setPersonName] = useState<any>("main");
  const [personId, setPersoneId] = React.useState("none");
  const [data, setData] = useState<any>({});
  const [state, setState] = useState<any>({});
  const [checked, setChecked] = React.useState(true);
  const [gravidaData, setGravidaData] = useState<boolean>(false);
  const [paraData, setParaData] = useState<boolean>(false);
  const [abortionData, setAbortionData] = useState<boolean>(false);
  const [liveData, setLiveData] = useState<boolean>(false);
  const [naturalData, setNaturalData] = useState<boolean>(false);
  const [assistedData, setAssistedData] = useState<boolean>(false);
  const [sselfData, setSelfData] = useState<boolean>(false);
  const [donorData, setDonorData] = useState<boolean>(false);
  const [spermData, setSpermData] = useState<boolean>(false);

  const bookingId = match.params.id;
  const componentRef = useRef<any>(null);

  useEffect(() => {
    if (booking_id !== 0) {
      getBiomarkerScreening(booking_id);
      getBookingById(booking_id);
      // getAdditionalMember(booking_id);
      // getBiomarkerUltasound(booking_id)
    }
  }, [booking_id]);

//   useEffect(() => {
//     getBiomarkerScreening(`?booking=${booking_id}`)
// }, [booking])

  const handleChange = (event: any) => {
    setPersonName(event.target.value);
    setState({ state, [event.target.name]: event.target.checked });

  };

  useEffect(() => {
    if (
      biomarkerScreening &&
      biomarkerScreening?.results &&
      biomarkerScreening?.results.length > 0
    ) {
      setData(biomarkerScreening.results[0]);
      setGravidaData(biomarkerScreening.results[0].gravida);
      setParaData(biomarkerScreening.results[0].para);
      setAbortionData(biomarkerScreening.results[0].abortion);
      setLiveData(biomarkerScreening.results[0].live);
      setNaturalData(biomarkerScreening.results[0].natural);
      setAssistedData(biomarkerScreening.results[0].assisted);
      setSelfData(biomarkerScreening.results[0].sself);
      setDonorData(biomarkerScreening.results[0].donor);
      setSpermData(biomarkerScreening.results[0].sperm);
    }
  }, [biomarkerScreening]);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);
  const reactToPrintTrigger = React.useCallback(() => {
    return <button style={{ marginLeft: "10px" }}>Print Receipt</button>;
  }, []);

  const handlePersonData = (event: any) => {
    setPersonName(booking_id);
    // getAdditionalMember(booking_id);
  };

  useEffect(()=>{
    if(personName==="main"){
        getBiomarkerScreening(`booking_id=${bookingId}`)
    }else{
        getBiomarkerScreening(`add_member_booking=${personName}`)
    }
   
},[personName])
  
  // useEffect(() => {
  //   if(personId!=="none"&&String(personId)===String(bookingId)){
  //     getBiomarkerScreening(`booking_id=${personId}`);
  //   }else if(personId!=="none"&&String(personId)!==String(bookingId)){
  //     getBiomarkerScreening(`add_member_booking=${personId}`);
  //   }
   
  // }, [personId]);

  return (
    <>
      <div>
        <div style={{ height: "20px", marginTop: "35%" }}>
          <div className={classes.rightContentHeader}>
            <Select
              className="input"
              name="priority"
              variant="outlined"
              style={{
                width: "100%",
                marginLeft: "1rem",
                marginBottom: "1rem",
                alignItems: "flex-start",
              }}
              value={personName}
              onChange={(e) => setPersonName(e.target.value)}
            >
              {/* <MenuItem disabled selected value={'none'}>Customer Name</MenuItem> */}
              <MenuItem value={"main"}>{booking?.customer_name}</MenuItem>
              {booking.additional_members &&
                booking.additional_members.length > 0 &&
                booking.additional_members.map((data: any) => {
                  return (
                    <MenuItem value={data?.id}>{data?.customer_name}</MenuItem>
                  );
                })}
            </Select>
            <ReactToPrint
              content={reactToPrintContent}
              trigger={reactToPrintTrigger}
            />
          </div>
        </div>
      </div>
      <div style={{ width: 1000, display: "block" }} ref={componentRef}>
        <div
          style={{
            display: "block",
            height: 1600,
            width: "100%",
            background: "#f1f1f1",
            padding: "15px",
            margin: "10px auto",
          }}
        >
          <div style={{ textAlign: "center", boxSizing: "border-box" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                background: "#AD70A6",
                marginTop: "52px",
              }}
            >
              <div style={{ width: "50%", textAlign: "left", padding: 15 }}>
                <h3>
                  <img src={image} alt="logo" style={{ width: "150px" }} />
                </h3>
              </div>
              <div style={{ width: "50%", textAlign: "right", padding: 15 }}>
                <div
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "25px",
                  }}
                >
                  DOUBLE MARKER FORM
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
              }}
            >
              <div style={{ width: "50%" }}>
                <h6
                  style={{
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "30px",
                    marginTop: "100px",
                    marginBottom: "35px",
                  }}
                >
                  PATIENTS DETAILS
                </h6>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <label
                      style={{
                        marginLeft: "-291px",
                        lineHeight: "1",
                        fontSize: "25px",
                      }}
                    >
                      Customer Name
                    </label>
                    <input
                      type="input"
                      style={{
                        width: "95%",
                        height: "40px",
                        display: "block",
                        marginLeft: "7px",
                      }}
                      value={personName==="main"? data?.booking?.customer_name:data?.add_member_booking?.customer_name}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    marginTop: "7px",
                  }}
                >
                  <div style={{ width: "49%" }}>
                    <label
                      style={{
                        marginLeft: "-164px",
                        lineHeight: "1",
                        fontSize: "25px",
                      }}
                    >
                      DOB
                    </label>
                    <input
                      type="input"
                      style={{
                        marginRight: "100px",
                        height: "40px",
                        width: "95%",
                        display: "block",
                        marginLeft: "7px",
                      }}
                      value={data?.dob}
                    />
                  </div>
                  <div style={{ width: "49%" }}>
                    <label
                      style={{
                        marginLeft: "-171px",
                        lineHeight: "1",
                        fontSize: "25px",
                      }}
                    >
                      Age
                    </label>
                    <input
                      type="input"
                      style={{
                        width: "95%",
                        height: "40px",
                        display: "block",
                        marginLeft: "7px",
                      }}
                      value={personName==="main"? data?.booking?.customer_age:data?.add_member_booking?.customer_age}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    marginTop: "7px",
                  }}
                >
                  <div style={{ width: "33%" }}>
                    <label
                      style={{
                        marginLeft: "-80px",
                        lineHeight: "1",
                        fontSize: "25px",
                      }}
                    >
                      Height
                    </label>
                    <input
                      type="input"
                      style={{
                        width: "95%",
                        height: "40px",
                        display: "block",
                        marginLeft: "7px",
                      }}
                      value={data?.height}
                    />
                  </div>
                  <div style={{ width: "33%" }}>
                    <label
                      style={{
                        marginLeft: "-64px",
                        lineHeight: "1",
                        fontSize: "25px",
                      }}
                    >
                      Weight
                    </label>
                    <input
                      type="input"
                      style={{
                        width: "95%",
                        height: "40px",
                        display: "block",
                        marginLeft: "7px",
                      }}
                      value={data?.weight}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    marginTop: "7px",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <label
                      style={{
                        marginRight: "500px",
                        lineHeight: "1",
                        fontSize: "25px",
                      }}
                    >
                      Address
                    </label>
                    <input
                      type="input"
                      style={{
                        width: "95%",
                        height: "40px",
                        display: "block",
                        marginLeft: "7px",
                      }}
                      value={personName==="main"? data?.booking?.customer_areapincode?.area:data?.add_member_booking?.customer_areapincode}
                    />
                  </div>
                </div>
                <h6
                  style={{
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "30px",
                    marginTop: "15px",
                  }}
                >
                  HISTORY
                </h6>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    fontSize: "25px",
                    marginRight: "100px",
                  }}
                >
                  <p>PARITY:</p>
                </div>
                <div>
                  <div>
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={gravidaData}
                          />
                        }
                        label="Gravida"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={paraData}
                            onChange={handleChange}
                          />
                        }
                        label="Para"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={abortionData}
                            onChange={handleChange}
                          />
                        }
                        label="Abortion"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={liveData}
                            onChange={handleChange}
                          />
                        }
                        label=" Live"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    fontSize: "25px",
                  }}
                >
                  <p>LAMP DATE</p>
                  <div style={{ width: "30%", height: "10px" }}>
                    <input
                      type="input"
                      style={{
                        width: "95%",
                        display: "block",
                        marginLeft: "5px",
                      }}
                      value={data?.lmp_date}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    fontSize: "25px",
                    marginRight: "100px",
                  }}
                >
                  <p>PROCEDURE TYPE:</p>
                </div>
                <div>
                  <div>
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              data?.procedure_type === "ivf" ? true : false
                            }
                            onChange={handleChange}
                          />
                        }
                        label="IVF"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              data?.procedure_type === "icsi" ? true : false
                            }
                            onChange={handleChange}
                          />
                        }
                        label="ICSI"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              data?.procedure_type === "iui" ? true : false
                            }
                            onChange={handleChange}
                          />
                        }
                        label="IUI"
                      />
                    </FormGroup>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    fontSize: "25px",
                    marginRight: "100px",
                  }}
                >
                  <p>PRESENT PREGNANCY:</p>
                </div>
                <div>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            data?.present_pregenancy === "singleton"
                              ? true
                              : false
                          }
                          onChange={handleChange}
                        />
                      }
                      label="Singleton"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            data?.present_pregenancy === "twin" ? true : false
                          }
                          onChange={handleChange}
                        />
                      }
                      label="Twin"
                    />
                  </FormGroup>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    fontSize: "25px",
                    marginRight: "100px",
                  }}
                >
                  <p>Nature of Conception:</p>
                </div>
                <div>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={naturalData}
                          onChange={handleChange}
                        />
                      }
                      label="Natural"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={assistedData}
                          onChange={handleChange}
                        />
                      }
                      label="Assisted"
                    />
                  </FormGroup>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    fontSize: "25px",
                    marginRight: "100px",
                  }}
                >
                  <p>If Assisted reproduction:</p>
                </div>
                <div>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={sselfData}
                          onChange={handleChange}
                        />
                      }
                      label="Self"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={donorData}
                          onChange={handleChange}
                        />
                      }
                      label="Donor"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={spermData}
                          onChange={handleChange}
                        />
                      }
                      label="Sperm"
                    />
                  </FormGroup>
                </div>
              </div>

              <div style={{ width: "50%" }}>
                <h6
                  style={{
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "30px",
                    marginTop: "100px",
                    marginBottom: "35px",
                  }}
                >
                  CLINICIAN DETAILS
                </h6>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <label
                      style={{
                        marginLeft: "-299px",
                        lineHeight: "1",
                        fontSize: "25px",
                      }}
                    >
                      Clinician Name
                    </label>
                    <input
                      type="input"
                      style={{
                        width: "95%",
                        display: "block",
                        height: "40px",
                        marginLeft: "7px",
                      }}
                      value={data?.clinician_name}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    marginTop: "7px",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <label
                      style={{
                        marginLeft: "-344px",
                        lineHeight: "1",
                        fontSize: "25px",
                      }}
                    >
                      Mobile No.
                    </label>
                    <input
                      type="input"
                      style={{
                        width: "95%",
                        height: "40px",
                        display: "block",
                        marginLeft: "7px",
                      }}
                      value={data?.mobile}
                    />
                  </div>
                </div>

                <h6
                  style={{
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "30px",
                    marginTop: "170px",
                  }}
                >
                  ULTRASOUND DETAILS
                </h6>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    fontSize: "25px",
                    marginTop: "15px",
                  }}
                >
                  <p>Date of USG</p>
                  <div style={{ width: "30%", height: "10px" }}>
                    <input
                      type="input"
                      style={{
                        width: "95%",
                        display: "block",
                        marginLeft: "7px",
                      }}
                      value={data?.date_of_usg}
                    />
                  </div>
                </div>
                {data?.present_pregenancy === "singleton" ? (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "10px",
                      }}
                    >
                      <p>CRL:</p>
                      <div
                        style={{
                          width: "30%",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <input
                          type="input"
                          style={{
                            width: 60,
                            height: 20,
                            marginLeft: "7px",
                          }}
                          value={
                            data &&
                            data.ultrasounddetails &&
                            data?.ultrasounddetails[0]?.crl
                          }
                        />{" "}
                        <p>mm</p>
                      </div>
                      <p>NT:</p>
                      <div
                        style={{
                          width: "30%",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <input
                          type="input"
                          style={{
                            width: 60,
                            height: 20,
                            marginLeft: "5px",
                          }}
                          value={
                            data &&
                            data.ultrasounddetails &&
                            data?.ultrasounddetails[0]?.nt
                          }
                        />{" "}
                        <p>mm</p>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "10px",
                      }}
                    >
                      <p>BPD:</p>
                      <div
                        style={{
                          width: "30%",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <input
                          type="input"
                          style={{
                            width: 60,
                            height: 20,
                            marginLeft: "5px",
                          }}
                          value={
                            data &&
                            data.ultrasounddetails &&
                            data?.ultrasounddetails[0]?.bpd
                          }
                        />{" "}
                        <p>mm</p>
                      </div>
                      <p>AC:</p>
                      <div
                        style={{
                          width: "30%",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <input
                          type="input"
                          style={{
                            width: 60,
                            height: 20,
                            marginLeft: "5px",
                          }}
                          value={
                            data &&
                            data.ultrasounddetails &&
                            data?.ultrasounddetails[0]?.ac
                          }
                        />{" "}
                        <p>mm</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          fontSize: "25px",
                          marginTop: "15px",
                        }}
                      >
                        <p>TWIN A</p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          marginTop: "10px",
                        }}
                      >
                        <p>CRL:</p>
                        <div
                          style={{
                            width: "30%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <input
                            type="input"
                            style={{
                              width: 60,
                              height: 20,
                              marginLeft: "5px",
                            }}
                            value={
                              data &&
                              data.ultrasounddetails &&
                              data?.ultrasounddetails[0]?.crl
                            }
                          />{" "}
                          <p>mm</p>
                        </div>
                        <p>NT:</p>
                        <div
                          style={{
                            width: "30%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <input
                            type="input"
                            style={{
                              width: 60,
                              height: 20,
                              marginLeft: "5px",
                            }}
                            value={
                              data &&
                              data.ultrasounddetails &&
                              data?.ultrasounddetails[0]?.nt
                            }
                          />{" "}
                          <p>mm</p>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          marginTop: "10px",
                        }}
                      >
                        <p>BPD:</p>
                        <div
                          style={{
                            width: "30%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <input
                            type="input"
                            style={{
                              width: 60,
                              height: 20,
                              marginLeft: "5px",
                            }}
                            value={
                              data &&
                              data.ultrasounddetails &&
                              data?.ultrasounddetails[0]?.bpd
                            }
                          />{" "}
                          <p>mm</p>
                        </div>
                        <p>AC:</p>
                        <div
                          style={{
                            width: "30%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <input
                            type="input"
                            style={{
                              width: 60,
                              height: 20,
                              marginLeft: "5px",
                            }}
                            value={
                              data &&
                              data.ultrasounddetails &&
                              data?.ultrasounddetails[0]?.ac
                            }
                          />{" "}
                          <p>mm</p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          fontSize: "25px",
                          marginTop: "15px",
                        }}
                      >
                        <p>TWIN B</p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          marginTop: "10px",
                        }}
                      >
                        <p>CRL:</p>
                        <div
                          style={{
                            width: "30%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <input
                            type="input"
                            style={{
                              width: 60,
                              height: 20,
                              marginLeft: "5px",
                            }}
                            value={
                              data &&
                              data.ultrasounddetails &&
                              data?.ultrasounddetails[1]?.crl
                            }
                          />
                          <p>mm</p>
                        </div>
                        <p>NT:</p>
                        <div
                          style={{
                            width: "30%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <input
                            type="input"
                            style={{
                              width: 60,
                              height: 20,
                              marginLeft: "5px",
                            }}
                            value={
                              data &&
                              data.ultrasounddetails &&
                              data?.ultrasounddetails[1]?.nt
                            }
                          />{" "}
                          <p>mm</p>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          marginTop: "10px",
                        }}
                      >
                        <p>BPD:</p>
                        <div
                          style={{
                            width: "30%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <input
                            type="input"
                            style={{
                              width: 60,
                              height: 20,
                              marginLeft: "5px",
                            }}
                            value={
                              data &&
                              data.ultrasounddetails &&
                              data?.ultrasounddetails[1]?.bpd
                            }
                          />{" "}
                          <p>mm</p>
                        </div>
                        <p>AC:</p>
                        <div
                          style={{
                            width: "30%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <input
                            type="input"
                            style={{
                              width: 60,
                              height: 20,
                              marginLeft: "5px",
                            }}
                            value={
                              data &&
                              data.ultrasounddetails &&
                              data?.ultrasounddetails[1]?.ac
                            }
                          />{" "}
                          <p>mm</p>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div
                  style={{
                    display: "flex",
                    width: "80%",
                    fontSize: "20px",
                    marginTop: "100px",
                  }}
                >
                  <p>Patient's Signature </p>
                  <div style={{ width: "50%" }}>
                    <img
                      style={{ width: "100px", height: "80px" }}
                      src={data?.patient_signature}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p>
                I/We have read and understood the terms and conditions mentioned
                above unconditionally accept them as binding on me/us. I/ We
                hereby undertake to pay all the charges raised on account of
                services availed. it is agreed that the data can be re-analysed
                or used by the company for research purpose. I/We fruther
                declare and undertake that the above information provided by
                me/us is true and correct in all aspects.
              </p>
            </div>
            <div>
              <footer
                style={{
                  background: "#AD70A6",
                  textAlign: "center",
                  padding: "20px",
                  color: "#fff",
                  border: "2px solid black",
                }}
              >
                <p>
                  <b>Redcliffe Lifesciences Pvt. Ltd.</b> &nbsp;{" "}
                  <p style={{ display: "inline" }}>
                    Building No: 14, 2nd Floor, Kausalya Park, Hauz Khas, New
                    Delih 110016
                  </p>
                </p>

                <p>
                  Phone: +91-8882-914-915 | &nbsp; Email: care@redcliffelabs.com
                  | &nbsp; Website: www.redcliffelabs.com
                </p>
              </footer>
            </div>
          </div>
        </div>
        <div>
          <div
            style={{
              display: "block",
              height: 1600,
              width: "100%",
              padding: "15px",
            }}
          >
            <h6
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              USG IMAGE-
            </h6>
            <img
              style={{ width: "auto", height: "100%" }}
              src={data?.attachment_one}
            />
          </div>
        </div>
        {/* <div className="pageBreak" /> */}
        <div
          style={{
            display: "block",
            height: 1600,
            width: "100%",
            padding: "15px",
          }}
        >
          <h6
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            {/* USG IMAGE -2 */}
          </h6>

          <img
            style={{ width: "auto", height: "100%" }}
            src={data?.attachment_two}
          />
        </div>
        <div
          style={{
            display: "block",
            height: 1600,
            width: "100%",
            padding: "15px",
          }}
        >
          <h6
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            {/* USG IMAGE -3 */}
          </h6>

          <img
            style={{ width: "auto", height: "100%" }}
            src={data?.attachment_three}
          />
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state: any) => ({
  biomarkerScreening: state.GenomicsSaReducer.biomarkerScreening,
  loading: state.GenomicsSaReducer.loading,
  booking: state.GenomicsSaReducer.booking,
  biomarkerUltasound: state.GenomicsSaReducer.biomarkerUltasound,
  // markerAdditionMember: state.GenomicsSaReducer.markerAdditionMember,
});

export default connect(mapStateToProps, {
  getBiomarkerScreening,
  getBookingById,
  getBiomarkerUltasound,
  // getAdditionalMember,
})(BiomarkerScreeningTestRequistionFrom);
